module.exports = __webpack_public_path__ + "static/media/novomatic.1686fb3f.svg";